var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"areaMap",staticStyle:{"overflow":"auto","height":"70vh","width":"calc(100vw - 488px)"},attrs:{"id":"areaMap"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shopPopup),expression:"shopPopup"}],ref:"popup",staticClass:"popup"})])
}
var staticRenderFns = []

export { render, staticRenderFns }